import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import * as React from 'react';

interface ISplashPageProps {}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      backgroundColor: theme.palette.primary.main,
      flexGrow: 1,
      margin: 0,
      overflow: 'hidden',
      width: '100%'
    },
    fullHeight: {
      height: '100vh'
    },
    img: {
      height: 'auto',
      paddingLeft: 6,
      paddingTop: 26,
      width: '95%'
    },
    logoContainer: { width: 150, position: 'relative' },
    noPadding: {
      padding: 0
    },
    spinner: {
      color: 'white',
      left: 0,
      position: 'absolute',
      top: 20
    }
  })
);

let SplashPage: React.FunctionComponent<ISplashPageProps> = ({}) => {
  const classes = useStyles();
  return (
    <Grid container className={classes.container}>
      <Grid item xs={12} className={classes.noPadding}>
        <Grid container className={classes.fullHeight} alignItems="center" direction="row" justify="center">
          <Grid className={classes.logoContainer}>
            <CircularProgress size={150} className={classes.spinner} thickness={1} />
            <img className={classes.img} src="https://static.shoremaster.com/img/wfb_llc_circle_white.png" />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

SplashPage = React.memo(SplashPage);
export { SplashPage };
